import { Link, useNavigate, useLocation } from 'react-router-dom';
import { MdDashboard, MdLogout, MdBadge, MdRestaurantMenu } from "react-icons/md";
import { FaUniversity, FaUsers } from "react-icons/fa";
import { IoStorefront } from "react-icons/io5";
import { HiDocumentReport } from "react-icons/hi";
import styles from './FooterNavigationMaster.module.css';

function FooterNavigationMaster() {
    const navigate = useNavigate();
    const location = useLocation();

    const handleLogout = () => {
        localStorage.clear();
        navigate('/');
    };

    const isActive = (path) => location.pathname === path;

    return (
        <footer className={styles.footermenu}>

            <div className={`${styles.menuItem} ${isActive('/speedhub/visaogeral') ? styles.active : ''}`}>
                <Link to="/speedhub/visaogeral">
                    <MdDashboard className={styles.iconeFooter} />
                    <span className={styles.labelFooter}>Visão Geral</span>
                </Link>
            </div>

            <div className={`${styles.menuItem} ${isActive('/speedhub/universidades') ? styles.active : ''}`}>
                <Link to="/speedhub/universidades">
                    <FaUniversity className={styles.iconeFooter} />
                    <span className={styles.labelFooter}>Universidades</span>
                </Link>
            </div>

            <div className={`${styles.menuItem} ${isActive('/speedhub/estabelecimentos') ? styles.active : ''}`}>
                <Link to="/speedhub/estabelecimentos">
                    <IoStorefront className={styles.iconeFooter} />
                    <span className={styles.labelFooter}>Estabelec.</span>
                </Link>
            </div>

            <div className={`${styles.menuItem} ${isActive('/speedhub/usuarios') ? styles.active : ''}`}>
                <Link to="/speedhub/usuarios">
                    <FaUsers className={styles.iconeFooter} />
                    <span className={styles.labelFooter}>Usuários</span>
                </Link>
            </div>

            <div className={`${styles.menuItem} ${isActive('/speedhub/equipe') ? styles.active : ''}`}>
                <Link to="/speedhub/equipe">
                    <MdBadge className={styles.iconeFooter} />
                    <span className={styles.labelFooter}>Equipe</span>
                </Link>
            </div>

            <div className={`${styles.menuItem} ${isActive('/speedhub/itens') ? styles.active : ''}`}>
                <Link to="/speedhub/itens">
                    <MdRestaurantMenu className={styles.iconeFooter} />
                    <span className={styles.labelFooter}>Itens</span>
                </Link>
            </div>

            <div className={`${styles.menuItem} ${isActive('/speedhub/relatorios') ? styles.active : ''}`}>
                <Link to="/speedhub/relatorios">
                    <HiDocumentReport className={styles.iconeFooter} />
                    <span className={styles.labelFooter}>Relatórios</span>
                </Link>
            </div>

            {/* A sidebar (onde fica "Sair da conta") some no mobile — sem isso
                não havia nenhum jeito de deslogar pelo celular. */}
            <div className={`${styles.menuItem} ${styles.logout}`}>
                <div onClick={handleLogout} role="button" tabIndex={0}>
                    <MdLogout className={styles.iconeFooter} />
                    <span className={styles.labelFooter}>Sair</span>
                </div>
            </div>

        </footer>
    );
}

export default FooterNavigationMaster;